<template>
  <CalicoDashboard>
    <template #drawer="{ show }">
      <CalicoDrawer :show="show">
        Drawer Content
      </CalicoDrawer>
    </template>
    <template #header>
      Header
    </template>
    <template #content>
      Content
    </template>
  </CalicoDashboard>
</template>

<script>
import CalicoDashboard from "@/components/template/dashboard/index.vue";
import CalicoDrawer from "@/components/calico/drawer/index.vue";

export default {
  name: "CalicoDashboardPage",
  components: {
    CalicoDashboard,
    CalicoDrawer
  },
  data() {
    return {
    }
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
</style>
